import { rem } from 'polished';
import styled from 'styled-components';
import { BodyText, Button } from '@unmind/design-system';
import { Chevron } from 'icons';

export const AddToCalendarButton = styled(Button).attrs({
  variant: 'secondary',
  size: 'small',
})`
  width: ${rem(185)};
  min-height: ${rem(40)};
`;

export const AddToCalendarButtonLabel = styled(BodyText).attrs(({ theme }) => ({
  sizes: [theme.typography.fontSizes.fontSize14],
  weight: theme.typography.fontWeights.regular,
}))`
  display: inline;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const ArrowIcon = styled(Chevron).attrs(({ theme }) => ({
  primaryColor: theme.colors.text.primary,
  width: rem(16),
  height: rem(16),
}))<{ $isOpen: boolean }>`
  margin-left: ${rem(6)};
  position: relative;
  top: ${rem(3)};
  transition: transform 0.2s ease;
  transform: ${props => (props.$isOpen ? 'rotate(-90deg)' : 'rotate(90deg)')};
`;
